<template>
  <v-row justify="center">
    <v-dialog v-model="openModal" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5">
        	Apakah anda yakin untuk menghapus TTB ini?
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" :disabled="loadingData" :loading="loadingData" text @click="$emit('cancel-delete')">
            Cancel
          </v-btn>
          <v-btn color="error darken-1" :disabled="loadingData" :loading="loadingData" text @click="$emit('process-delete')">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
	name: 'ConfirmDelete',
  props: ["openModal", "loadingData"],
};
</script>
